export const TRANSLATIONS_CLIENTS = {
  title: 'clients.title',
  count: 'clients.count',
  status: {
    active: 'clients.status.active',
    awaitingStart: 'clients.status.awaiting_start'
  },
  profile: {
    back: 'clients.profile.back',
    notFound: 'clients.profile.not_found',
    activationError: {
      alert: 'clients.profile.activation_error.alert'
    },
    sections: {
      activePlans: 'clients.profile.sections.active_plans',
      plansInSetup: 'clients.profile.sections.plans_in_setup',
      quotes: 'clients.profile.sections.quotes',
      clientData: 'clients.profile.sections.client_data',
      activity: 'clients.profile.sections.activity'
    },
    quotes: {
      empty: 'clients.profile.quotes.empty',
      acceptDisabledTooltip: 'clients.profile.quotes.accept_disabled_tooltip'
    },
    plansInSetup: {
      badgeReady: 'clients.profile.plans_in_setup.badge_ready',
      badgeInSetup: 'clients.profile.plans_in_setup.badge_in_setup',
      summaryComplete: 'clients.profile.plans_in_setup.summary_complete',
      summaryProgress: 'clients.profile.plans_in_setup.summary_progress',
      activate: 'clients.profile.plans_in_setup.activate'
    },
    planDetails: {
      title: 'clients.profile.plan_details.title',
      sections: {
        planCoverage: 'clients.profile.plan_details.sections.plan_coverage',
        voluntaryBenefits: 'clients.profile.plan_details.sections.voluntary_benefits'
      },
      fields: {
        effectiveDate: 'clients.profile.plan_details.fields.effective_date',
        renewalDate: 'clients.profile.plan_details.fields.renewal_date'
      },
      table: {
        benefit: 'clients.profile.plan_details.table.benefit',
        option: 'clients.profile.plan_details.table.option'
      },
      actions: {
        close: 'clients.profile.plan_details.actions.close'
      }
    },
    plans: {
      empty: {
        title: 'clients.profile.plans.empty.title',
        description: 'clients.profile.plans.empty.description'
      },
      viewDetails: 'clients.profile.plans.view_details',
      status: {
        enrolling: 'clients.profile.plans.status.enrolling',
        awaitingStart: 'clients.profile.plans.status.awaiting_start',
        active: 'clients.profile.plans.status.active'
      },
      summary: {
        activeSince: 'clients.profile.plans.summary.active_since',
        renews: 'clients.profile.plans.summary.renews',
        enrollmentOpens: 'clients.profile.plans.summary.enrollment_opens',
        coverageStarts: 'clients.profile.plans.summary.coverage_starts',
        notScheduled: 'clients.profile.plans.summary.not_scheduled',
        daysLeft: 'clients.profile.plans.summary.days_left',
        starts: 'clients.profile.plans.summary.starts',
        startDateNotSet: 'clients.profile.plans.summary.start_date_not_set',
        activationFailed: 'clients.profile.plans.summary.activation_failed'
      },
      enrollment: {
        title: 'clients.profile.plans.enrollment.title',
        daysLeft: 'clients.profile.plans.enrollment.days_left',
        timeline: {
          opens: 'clients.profile.plans.enrollment.timeline.opens',
          closes: 'clients.profile.plans.enrollment.timeline.closes',
          coverageStarts: 'clients.profile.plans.enrollment.timeline.coverage_starts'
        }
      },
      details: {
        effectiveDate: 'clients.profile.plans.details.effective_date',
        startDate: 'clients.profile.plans.details.start_date',
        employeesWithAccess: 'clients.profile.plans.details.employees_with_access',
        plan: 'clients.profile.plans.details.plan',
        monthlyRate: 'clients.profile.plans.details.monthly_rate',
        perEmployeeAmount: 'clients.profile.plans.details.per_employee_amount',
        renewalDate: 'clients.profile.plans.details.renewal_date',
        segment: 'clients.profile.plans.details.segment',
        enrollmentOpens: 'clients.profile.plans.details.enrollment_opens',
        allSegments: 'clients.profile.plans.details.all_segments',
        empty: 'clients.profile.plans.details.empty'
      }
    },
    contacts: {
      empty: 'clients.profile.contacts.empty',
      error: 'clients.profile.contacts.error',
      roles: {
        administrator: 'clients.profile.contacts.roles.administrator',
        paymentManager: 'clients.profile.contacts.roles.payment_manager'
      }
    }
  },
  clientsList: {
    searchPlaceholder: 'clients.list.search_placeholder',
    columns: {
      company: 'clients.list.columns.company',
      companySize: 'clients.list.columns.company_size',
      industry: 'clients.list.columns.industry',
      enrollmentWindow: 'clients.list.columns.enrollment_window',
      location: 'clients.list.columns.location'
    },
    badges: {
      new: 'clients.list.badges.new',
      activationError: 'clients.list.badges.activation_error'
    },
    activationErrorBanner: {
      one: 'clients.list.activation_error_banner.one',
      many: 'clients.list.activation_error_banner.many',
      action: 'clients.list.activation_error_banner.action',
      dismiss: 'clients.list.activation_error_banner.dismiss'
    },
    rowAction: 'clients.list.row_action',
    states: {
      empty: {
        title: 'clients.list.states.empty.title',
        description: 'clients.list.states.empty.description'
      },
      noActive: {
        title: 'clients.list.states.no_active.title',
        description: 'clients.list.states.no_active.description'
      },
      noAwaitingStart: {
        title: 'clients.list.states.no_awaiting_start.title',
        description: 'clients.list.states.no_awaiting_start.description'
      },
      noResults: {
        title: 'clients.list.states.no_results.title',
        description: 'clients.list.states.no_results.description'
      },
      error: {
        title: 'clients.list.states.error.title',
        description: 'clients.list.states.error.description',
        retry: 'clients.list.states.error.retry'
      }
    }
  }
};
